import { consts } from '@app/styles'
import type React from 'react'
import { BulletCircle } from '.'

type IBulletStatusOKProps = {}

const BulletStatusOK: React.FC<IBulletStatusOKProps> = props => {
  return <BulletCircle color={consts.colorGreen020} />
}

export default BulletStatusOK
